import ReactDOM from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App.jsx'

registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    registration?.update()
  },
  onRegisterError(error) {
    console.error('Service worker registration failed:', error)
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(<App />)
